import React from 'react';
import Drawer from 'react-toolbox/lib/drawer';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { not } from 'ramda';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { getItem } from 'utils/localStorage';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Drawer.scss';// to import local scss fle

class MenuDrawer extends React.Component {
  static isEmpty(val) {
    if (val) {
      return false;
    }
    return true;
  }

  static propTypes = {
    user: PropTypes.shape(),
    logoutUser: PropTypes.func,
    attributes: PropTypes.shape(),
  };
  static defaultProps = {
    user: {},
    logoutUser: () => {},
    attributes: {},
  };

  state = {
    active: false,
    profileIcon: '',
  };
  componentWillMount() {
    const profileImage = getItem('profile_image');
    this.setState({ profileIcon: profileImage });
  }
  handleSignOut = () => {
    this.props.logoutUser(this.props.attributes.get('zoneinfo'));
    this.handleToggle();
  }

  handleToggle = () => {
    this.setState({ active: !this.state.active });
  };

  render() {
    const { user = Map(), attributes } = this.props;
    const username = user.username;
    const renderCoachItems = renderIf(attributes.get('zoneinfo') === 'COACH');
    const renderAthleteItems = renderIf(attributes.get('zoneinfo') === 'STUDENT');
    const renderLoggedOutLinks = renderIf(MenuDrawer.isEmpty(username));
    const renderLoggedInLinks = renderIf(not(MenuDrawer.isEmpty(username)));
    return (
      <div className={styles.container}>
        <button className={styles.menuIcon} onClick={this.handleToggle}><img alt="menu" src="https://media.dev.myrecruitboard.com/Images/menu.png" /></button>
        <Drawer active={this.state.active} className={cn('row', styles.drawerContainer)} type="right" onOverlayClick={this.handleToggle}>
          <div className={cn('col s12', styles.closeButton)}>
            <button onClick={this.handleToggle}><img src="https://media.dev.myrecruitboard.com/Images/whiteCross.png" alt="close" /></button>
          </div>
          {renderLoggedInLinks(
            <div className={cn('col s12')}>

              {renderCoachItems(
                <img
                  id="text"
                  className={styles.dropdownIcon}
                  src="https://media.dev.myrecruitboard.com/Images/coachIcon.png"
                  alt="icon"
                />,
                )}
              {renderAthleteItems(
                <img
                  className={styles.dropdownIcon}
                  src={this.state.profileIcon !== '' ?
                            `https://s3.amazonaws.com/myrbimagesdev/${this.state.profileIcon}` :
                            'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png'}
                  alt="icon"
                />,
                )}
              <span className={styles.userName}>
                {attributes.get('name')}
              </span>
            </div>,
            )}
          {renderLoggedInLinks(
            <div>
              {renderCoachItems(
                <Link to="view/coach/dashboard">
                  <button>
                        DASHBOARD
                      </button>
                </Link>,
                )}
              {renderAthleteItems(
                <div>
                  <Link to="/dashboard">
                    <button>
                      DASHBOARD
                  </button>
                  </Link>
                  <Link to="/view/athlete">
                    <button>
                    PROFILE
                    </button>
                  </Link>
                </div>,
                )}

              <Link to="/settings">
                <button>
                  SETTINGS
              </button>
              </Link>
              <Link to="/">
                <button onClick={this.handleSignOut}>
                 SIGNOUT
             </button>
              </Link>
            </div>,
            )}
          {renderLoggedOutLinks(
            <div className={cn('col s12', styles.buttonContainer)}>
              <Link to="/">
                <button>
                  HOME
                </button>
              </Link>
              <Link to="/about">
                <button>
                  ABOUT US
                </button>
              </Link>
              <Link to="/terms_and_use">
                <button>
                  TERMS OF USE
                </button>
              </Link>
              <Link to="/contact">
                <button>
                  CONTACT
                </button>
              </Link>
              <Link to="/pricing">
                <button>
                  PRICING
                </button>
              </Link>
              <Link to="/sports">
                <button>
                  WHY
                </button>
              </Link>
              <div className={cn('col s6', styles.loginButtonContainer)}>
                <Link to="/login">
                  <button>SIGN IN</button>
                </Link>
              </div>
              <div className={cn('col s6', styles.joinUsButtonContainer)}>
                <Link to="/register">
                  <button>JOIN US</button>
                </Link>
              </div>
            </div>,
          )}
        </Drawer>
      </div>
    );
  }
}

export default MenuDrawer;



// WEBPACK FOOTER //
// ./src/components/MenuDrawer/Drawer.js